import React, { useEffect } from 'react';

import { RocketImage } from 'src/assets/images';
import { InfoTray } from 'src/components';
import './approved-modal.scss';

type ApprovedHeadProps = {
  disabled: boolean;
  onHide: () => void;
};

function ApprovedHead({ disabled, onHide }: ApprovedHeadProps) {
  return (
    <>
      <button
        className="close-button icon-cross is-icon-4 is-pulled-right is-hidden-mobile"
        disabled={disabled}
        onClick={() => {
          if (!disabled) {
            onHide();
          }
        }}
      ></button>
    </>
  );
}

function ApprovedBody() {
  return (
    <div>
      <img src={RocketImage} alt="Red launching rocket" />
      <p>Your Business Cash Advance application was successful</p>
    </div>
  );
}

type ApprovedFootProps = {
  onRedirectContract: () => void;
};

function ApprovedFoot({ onRedirectContract }: ApprovedFootProps) {
  return (
    <div className="accept-button-container">
      <button
        className="button is-fullwidth accept-button"
        onClick={onRedirectContract}
        automationid="BCA_Button_Close_Modal"
      >
        View contract
      </button>
    </div>
  );
}

type ApprovedModalProps = {
  show: boolean;
  onApplicationSuccessful: () => void;
  onRedirectContract: () => void;
  onHide: () => void;
  disabled?: boolean;
};

export default function ApprovedModal({
  show,
  onApplicationSuccessful,
  onRedirectContract,
  onHide,
  disabled = false,
}: ApprovedModalProps) {
  useEffect(() => {
    if (show && onApplicationSuccessful) {
      onApplicationSuccessful();
    }
  }, [show]);

  return (
    <div className="ApprovedModal">
      <div className={`modal ${show ? 'is-active' : ''} is-hidden-mobile`}>
        <div className="modal-background"></div>
        <div className="modal-card">
          <header className="modal-card-head">
            <ApprovedHead disabled={disabled} onHide={onHide} />
          </header>
          <section className="modal-card-body has-text-centered">
            <ApprovedBody />
          </section>
          <footer className="modal-card-foot">
            <ApprovedFoot onRedirectContract={onRedirectContract} />
          </footer>
        </div>
      </div>
      <InfoTray
        selected={show}
        setSelected={() => onHide()}
        title=""
        isFullscreen={true}
        className="is-hidden-tablet"
      >
        <p className="top-mobile-page-title navbar-title-mobile is-hidden-tablet">Get Financed</p>
        <ApprovedHead disabled={disabled} onHide={onHide} />
        <section className="has-text-centered info-tray-body">
          <ApprovedBody />
        </section>
        <ApprovedFoot onRedirectContract={onRedirectContract} />
      </InfoTray>
    </div>
  );
}
